// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sect-following {
    margin-top: 50px;
    margin-bottom: 10px;
}

.custom-container {
    max-width: 800px;
}

.following-row {
    margin-bottom: 20px;
}

.following-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.following-list li {
    /*display: block;*/
    /*margin-bottom: 10px;*/
    /*height: 92px;*/
    /*border: 1px solid red !important;*/
    padding: 10px;
    display: flex;
    margin: 1px;
}

.following-list li:hover {
    border-radius: 5px;
    box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);
}

.following-image {
    min-width: 70px;
    width: 70px;
    height: 70px;
    /*float: left;*/
    overflow: hidden;
    border-radius: 13px;
}

.following-image img {
    width: 100%;
    height: 100%;
    cursor: pointer;
    object-fit: cover;
}

.following-info {
    /*max-width: 580px;*/
    max-width: 650px;
    /*float: left;*/
    /*height: 60px;*/
    padding-left: 15px;
    padding-right: 15px;
}

.following-info p {
    line-break: anywhere;
    font-size: 13px;
    font-weight: 400;
    color: #878395;
    /*max-width: 580px;*/
    max-width: 650px;
    padding-right: 15px;
}

.following-info h5 {
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 500;
}

.following-info span {
    margin-right: 20px;
    font-size: 14px;
    font-weight: 400;
}

.following-info p {
    margin-bottom: 0;
    font-size: 13px;
}

.btn-holder {
    /*width: calc(100% - 650px);*/
    /*height: 70px;*/
    /*float: left;*/
    margin-left: auto;
}

.btn-holder button {
    /*float: right;*/
    /*width: auto;*/
    background-color: #FFF;
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    border-radius: 5px;
    padding: 3px 10px;
}

.btn-holder button.follow {
    background-color: #6c2fbb;
    color: #fff;
    border: 1px solid #fff;
}

.FF-scroll-modify {
    min-height: 30vh;
    max-height: 600px;
    height: auto;
    overflow-x: hidden;
    overflow-y: scroll;
}

@media (max-width: 991px) {
    /*.following-list li*/
    /*{*/
    /*    height: auto;*/
    /*    display: block;*/
    /*    width: 100%;*/
    /*}*/
    /*.following-info*/
    /*{*/
    /*    float: none;*/
    /*    width: calc(100% - 65px);*/
    /*    height: auto;*/
    /*    display: block;*/
    /*    margin-left: 65px;*/
    /*}*/
    .sect-following {
        margin-bottom: 100px;
    }

    /*.btn-holder,.btn-holder button*/
    /*{*/
    /*    float: none;*/
    /*    width: auto;*/
    /*    height: auto;*/
    /*    display: block;*/
    /*    */
    /*}*/
    /*.btn-holder*/
    /*{*/
    /*    margin: 15px 0px*/
    /*}*/
}

@media (max-width: 768px) {
    .following-list li {
        flex-wrap: wrap;
    }

    .btn-holder {
        order: 2;
    }

    .following-info {
        order: 3;
        max-width: 100%;
        padding-left: 0;
        padding-top: 10px;
        width: 100%;
    }

}

.profile-image {
    width: 70px;
    height: 70px;
    border-radius: 13px;
    color: #ffc266;
    background: #bd50d0;
    font-size: 30px;
    font-weight: 600;
  }
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/followers/followers.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,oCAAoC;IACpC,aAAa;IACb,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,IAAI;IACJ,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,IAAI;IACJ,kBAAkB;IAClB,IAAI;IACJ,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;IACzB,IAAI;IACJ;QACI,oBAAoB;IACxB;;IAEA,iCAAiC;IACjC,IAAI;IACJ,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,OAAO;IACP,IAAI;IACJ,cAAc;IACd,IAAI;IACJ,uBAAuB;IACvB,IAAI;AACR;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;QACR,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,WAAW;IACf;;AAEJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB","sourcesContent":[".sect-following {\r\n    margin-top: 50px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.custom-container {\r\n    max-width: 800px;\r\n}\r\n\r\n.following-row {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.following-list {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.following-list li {\r\n    /*display: block;*/\r\n    /*margin-bottom: 10px;*/\r\n    /*height: 92px;*/\r\n    /*border: 1px solid red !important;*/\r\n    padding: 10px;\r\n    display: flex;\r\n    margin: 1px;\r\n}\r\n\r\n.following-list li:hover {\r\n    border-radius: 5px;\r\n    box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);\r\n}\r\n\r\n.following-image {\r\n    min-width: 70px;\r\n    width: 70px;\r\n    height: 70px;\r\n    /*float: left;*/\r\n    overflow: hidden;\r\n    border-radius: 13px;\r\n}\r\n\r\n.following-image img {\r\n    width: 100%;\r\n    height: 100%;\r\n    cursor: pointer;\r\n    object-fit: cover;\r\n}\r\n\r\n.following-info {\r\n    /*max-width: 580px;*/\r\n    max-width: 650px;\r\n    /*float: left;*/\r\n    /*height: 60px;*/\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n}\r\n\r\n.following-info p {\r\n    line-break: anywhere;\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n    color: #878395;\r\n    /*max-width: 580px;*/\r\n    max-width: 650px;\r\n    padding-right: 15px;\r\n}\r\n\r\n.following-info h5 {\r\n    margin-bottom: 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n}\r\n\r\n.following-info span {\r\n    margin-right: 20px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n}\r\n\r\n.following-info p {\r\n    margin-bottom: 0;\r\n    font-size: 13px;\r\n}\r\n\r\n.btn-holder {\r\n    /*width: calc(100% - 650px);*/\r\n    /*height: 70px;*/\r\n    /*float: left;*/\r\n    margin-left: auto;\r\n}\r\n\r\n.btn-holder button {\r\n    /*float: right;*/\r\n    /*width: auto;*/\r\n    background-color: #FFF;\r\n    color: #6c2fbb;\r\n    border: 1px solid #6c2fbb;\r\n    border-radius: 5px;\r\n    padding: 3px 10px;\r\n}\r\n\r\n.btn-holder button.follow {\r\n    background-color: #6c2fbb;\r\n    color: #fff;\r\n    border: 1px solid #fff;\r\n}\r\n\r\n.FF-scroll-modify {\r\n    min-height: 30vh;\r\n    max-height: 600px;\r\n    height: auto;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    /*.following-list li*/\r\n    /*{*/\r\n    /*    height: auto;*/\r\n    /*    display: block;*/\r\n    /*    width: 100%;*/\r\n    /*}*/\r\n    /*.following-info*/\r\n    /*{*/\r\n    /*    float: none;*/\r\n    /*    width: calc(100% - 65px);*/\r\n    /*    height: auto;*/\r\n    /*    display: block;*/\r\n    /*    margin-left: 65px;*/\r\n    /*}*/\r\n    .sect-following {\r\n        margin-bottom: 100px;\r\n    }\r\n\r\n    /*.btn-holder,.btn-holder button*/\r\n    /*{*/\r\n    /*    float: none;*/\r\n    /*    width: auto;*/\r\n    /*    height: auto;*/\r\n    /*    display: block;*/\r\n    /*    */\r\n    /*}*/\r\n    /*.btn-holder*/\r\n    /*{*/\r\n    /*    margin: 15px 0px*/\r\n    /*}*/\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .following-list li {\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .btn-holder {\r\n        order: 2;\r\n    }\r\n\r\n    .following-info {\r\n        order: 3;\r\n        max-width: 100%;\r\n        padding-left: 0;\r\n        padding-top: 10px;\r\n        width: 100%;\r\n    }\r\n\r\n}\r\n\r\n.profile-image {\r\n    width: 70px;\r\n    height: 70px;\r\n    border-radius: 13px;\r\n    color: #ffc266;\r\n    background: #bd50d0;\r\n    font-size: 30px;\r\n    font-weight: 600;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
